export const isServerSide = () => typeof document === 'undefined';

export const isClientSide = () => typeof document !== 'undefined';

export default { isServerSide, isClientSide };
